import Amplify from '@aws-amplify/core';
import { Auth } from './constants';

Amplify.configure({
  Auth: {
    ...Auth,
    mandatorySignIn: false,
  },
});
